import React from 'react';
import { ListItem, Text, useStyles } from '@chakra-ui/react';

interface EntryItemProps {
  field: string;
  value: string;
  children?: React.ReactNode;
}

// Shared patient-timeline detail row used by both entry templates and provider
// rendering. Keeping it in a leaf module avoids a cycle between those files.
function EntryItem(props: Readonly<EntryItemProps>) {
  const { field, value, children } = props;
  const styles = useStyles();
  return (
    <ListItem role="menuitem" as="text" __css={styles.listitem}>
      <Text as="span" sx={styles.field}>
        {field}{' '}
      </Text>
      <Text as="span" sx={styles.value}>
        {value}
      </Text>
      {children}
    </ListItem>
  );
}

export { EntryItem };
